export const FETCH_CART_DATA = 'FETCH_CART_DATA';
export const UPDATE_CART_QUANTITY = 'UPDATE_CART_QUANTITY';
export const DELETE_CART_ITEM = 'DELETE_CART_ITEM';
export const POST_CART_ITEM = 'POST_CART_ITEM';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const RECALCULATE_TOTALS = 'RECALCULATE_TOTALS';
export const GET_PRODUCT_INFO = 'GET_PRODUCT_INFO';
export const UPDATE_ITEM_PRICE = 'UPDATE_ITEM_PRICE';
export const SET_PRODUCT_PRICES = 'SET_PRODUCT_PRICES';
export const FETCH_REFRESHED_CART_DATA = 'FETCH_REFRESHED_CART_DATA';
export const UPDATE_AFTER_ADD_OR_DELETE = 'UPDATE_AFTER_ADD_OR_DELETE';
export const SET_SUGGESTED_PRODUCT_PRICES = 'SET_SUGGESTED_PRODUCT_PRICES';


// notification
export const ADD_ITEM_NOTIFICATION = 'ADD_ITEM_NOTIFICATION';
export const FETCH_ITEM_NOTIFICATIONS = 'FETCH_ITEM_NOTIFICATIONS';

// search
export const FETCH_RELATED_CART_ITEMS = 'FETCH_RELATED_CART_ITEMS';
export const UPDATE_ITEM_LOADED_COUNT = 'UPDATE_ITEM_LOADED_COUNT';

export default {
    FETCH_CART_DATA,
    UPDATE_CART_QUANTITY,
    DELETE_CART_ITEM,
    POST_CART_ITEM,
    REMOVE_CART_ITEM,
    RECALCULATE_TOTALS,
    GET_PRODUCT_INFO,
    UPDATE_ITEM_PRICE,
    SET_PRODUCT_PRICES,
    FETCH_REFRESHED_CART_DATA,
    UPDATE_AFTER_ADD_OR_DELETE,
    SET_SUGGESTED_PRODUCT_PRICES,
    ADD_ITEM_NOTIFICATION,
    FETCH_ITEM_NOTIFICATIONS,
    FETCH_RELATED_CART_ITEMS,
    UPDATE_ITEM_LOADED_COUNT,
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/cart/mutations.js